import { usePlayerStore } from '@slot-nx/core'
import { TextStyle } from 'pixi.js'
import { Balance } from './Balance'

interface BalanceContainerProps {
  x: number
  y: number
}

export const BalanceContainer = (props: BalanceContainerProps) => {
  const [currency] = usePlayerStore(x => [x.currency])
  return (
    <Balance
      x={props.x}
      y={props.y}
      width={400}
      height={100}
      currency={currency}
      currencyStyle={textCurrencyStyle}
      titleStyle={textTitleStyle}
      amountStyle={textAmountStyle}
    />
  )
}

const textCurrencyStyle = new TextStyle({
  fontSize: 24,
  fill: '#FF74A8',
  align: 'left',
  stroke: '#FF74A8',
  strokeThickness: 1.5,
  // dropShadow: true,
  // dropShadowColor: '#0c0c0c',
  // dropShadowBlur: 6,
  // dropShadowAngle: 1,
  // dropShadowDistance: 3,
})
const textTitleStyle = new TextStyle({
  fontSize: 38,
  fill: '#FFC0D8',
  align: 'center',
  stroke: '#FFC0D8',
  strokeThickness: 2,
  letterSpacing: 2,
  // dropShadow: true, // 必須設為 true 才會啟用
  // dropShadowColor: '#0c0c0c', // 陰影顏色
  // dropShadowBlur: 6, // 陰影的擴散(柔焦)
  // dropShadowAngle: 1, // 陰影的角
  // dropShadowDistance: 3, // 陰影距離
})
const textAmountStyle = new TextStyle({
  fontSize: 38,
  fill: '#FFFFFF',
  align: 'center',
})
